import React, { useEffect, useContext, useState } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import Faq from "react-faq-component";
import { SystemContext } from "../components/SystemConfig/SystemContext";

const FaqPlataforma = () => {
  const { company } = useContext(SystemContext);
  const [price, setPrice] = useState("");

  useEffect(() => {
    if (company.label === "tok_stok") {
      setPrice(
        (325).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })
      );
    } else if (company.label === "leroymerlinprojeta") {
      setPrice(
        (379).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })
      );
    } else {
      setPrice(
        (299 + company.priceIncrease).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        })
      );
    }
  }, []);

  let data = {
    rows: [
      {
        title: `Como funciona a ${company.name}?`,
        content: `Após a compra do ambiente, serão liberados os seguintes acessos ao cliente: <br />
        Cronograma com etapas de envio de informações para a assessoria:
        <ul>
          <li>Questionário 1: Envio de fotos do local e planta do ambiente; </li>
          <li>Questionário 2: Estilos e preferências. </li>
        </ul>
        Após o envio de todas as informações necessárias, nossos decoradores desenvolvem o seu ambiente personalizado. Você também poderá descrever as suas solicitações à parte, para que tenhamos todas as suas referências para entregarmos um ambiente com a sua cara.
        `,
      },
      {
        title: `Como faço para comprar o projeto?`,
        content: `Você pode selecionar o ambiente que deseja decorar e seguir para o carrinho de compras, onde será necessário concluir seu cadastro na plataforma, assim será direcionado para a compra via cartão de crédito ou PIX. Após a confirmação de compra, o ambiente selecionado será liberado na sua plataforma para início da jornada de decoração.`,
      },
      {
        title:
          "Eu enviei as fotos erradas nos questionários iniciais do ambiente. É possível corrigir as imagens enviadas?",
        content: `
        Sim, você pode revisar seu questionário antes do início da assessoria. Se tiver dificuldade poderá nos solicitar ajuda pelo SAC.
        `,
      },
      {
        title:
          "Tenho fotos de um ambiente pronto que gostaria de usar como inspiração. Onde posso enviar estas imagens?",
        content: `
        Sim, no processo de atendimento será solicitado o envio de imagens de inspiração.
        `,
      },
      {
        title: `Já utilizei o serviço ${company.name} e gostaria de ter o mesmo decorador em meu próximo ambiente. É possível escolher o profissional que vai realizar o serviço?`,
        content: `
       Não é possível escolher o decorador que irá realizar o serviço, porém nosso time é treinado com uma metodologia única que garante a satisfação do cliente.
        `,
      },
      {
        title: "O que está incluso no ambiente final?",
        content: `
        Após a conclusão da etapa de envio de informações, nossos decoradores criam o seu ambiente personalizado e, assim que ele estiver pronto, o sistema disponibiliza as imagens 3D para a sua aprovação. <br />
        Com a aprovação do 3D, nossa equipe monta todo o material técnico, que contém: <br />
        - Posicionamento  da decoração; <br />
        - Posicionamento  de luminárias; <br />
        - Sugestão de  acabamentos de paredes; <br />
        - Ambiente decorado com imagens em  3D; <br />
        - Tabelas técnicas de móveis, decoração, luminárias, papel de parede, cortinas, persianas, tapetes e toda a decoração; <br />
        - Considerações para executar a decoração; <br />
        - Dicas úteis e personalizadas de decoração; <br />
        `,
      },
      {
        title:
          "Qual é o formato dos arquivos que fazem parte do material técnico e das imagens em 3D? É necessário ter algum programa especial para abri-los?",
        content: `
        Não é necessário ter programa especial para abrir, pois as imagens serão enviadas em formato JPG e o material técnico em formato PDF.
        `,
      },
      {
        title:
          "É possível abrir as imagens 3D e o material técnico no meu celular?",
        content: `
        Sim, nosso sistema é responsivo para celular.
        `,
      },
      {
        title:
          "Estou recebendo uma mensagem de erro ao tentar abrir as imagens 3D e/ou o material técnico. O que eu faço?",
        content: `
        Poderá fechar o sistema e abrir novamente para atualização. Caso o problema persista favor entrar em contato via SAC e informar o erro.
        `,
      },
      {
        title: `Para quem o serviço ${company.name} é indicado?`,
        content: `
        O ${company.name} é indicado para todos que sonham em ter um ambiente decorado, profissional, prático e acessível. As assessorias são contratadas por ambiente e você tem a liberdade de realizar a decoração de acordo com o seu tempo, com o auxílio total de nossa assessoria em 3D e um material técnico explicativo para seguir passo a passo.
        `,
      },

      {
        title: "Eu quero reformar, este serviço me atende?",
        content: `
        O ${company.name} é um serviço exclusivamente de decoração online. Ele não abrange modificações estruturais, hidráulicas ou elétricas com aumento de carga. Portanto, caso você busque uma reforma, você deve contratar um arquiteto ou engenheiro local para a execução de um projeto de reforma e nos enviar a planta aprovada para desenvolvermos a decoração.
        `,
      },
      {
        title: "Quais os tipos de ambientes que o serviço abrange?",
        content: `
        O ${company.name} pode ser utilizado em qualquer canto da sua casa que você deseje decorar! Nossos decoradores estão à disposição para entregar assessorias de salas de estar, salas de jantar, quartos, cozinhas, banheiros e qualquer outro cômodo que você tenha em mente. Você tem a oportunidade de explicar tudo o que precisa no início da assessoria para que nós possamos entregar algo do jeito que você deseja.
        `,
      },
      {
        title: "O serviço também é válido para áreas externas?",
        content: `
        Sim, nossos decoradores também realizam o serviço de decoração para áreas externas, como varandas e quintais, por exemplo.
        `,
      },
      {
        title: "Qual é o prazo de entrega do assessoria completa?",
        content: `
        Após a conclusão da etapa de envio de informações para o início da assessoria, o prazo de entrega é de 5 (cinco) dias úteis para envio do projeto 3D. Após a aprovação dele pelo cliente, há um prazo de 3 (três) dias úteis para envio do material técnico.
        `,
      },
      {
        title: "É possível solicitar uma revisão da assessoria?",
        content: `
        Sim, você pode solicitar até 2 (duas) revisões em até 20 (vinte) dias corridos após envio da primeira versão. Caso o cliente não solicite nenhuma revisão dentro do prazo estipulado, a assessoria será considerada aprovada pelo sistema e o material técnico será enviado em 3 (três) dias úteis.
        `,
      },
      {
        title:
          "Eu aprovei o ambiente 3D, mas gostaria de solicitar uma revisão. É possível voltar atrás?",
        content: `
        Não. Depois que o cliente aprova as imagens 3D, nossos decoradores já iniciam a elaboração do material técnico, o que impede qualquer nova alteração. Poderá ser feita solicitação de revisão extra no valor de R$150,00 via SAC.
        `,
      },
      {
        title:
          "Eu gostaria de aproveitar alguns móveis que já tenho. Como posso incluí-los na assessoria?",
        content: `
        Para aproveitar seus móveis atuais, você só precisa nos enviar as fotos e medidas de todos os objetos que deseja manter e vamos considerá-los na elaboração da assessoria.
        `,
      },
      {
        title: `Eu posso contratar o serviço ${company.name} nas lojas físicas?`,
        content: `
        No momento, o serviço está apenas disponível em nosso site.
        `,
      },
      {
        title: `Qual é o custo do serviço ${company.name}`,
        content: `
        O serviço possui um valor padrão de ${price} por ambientede até 14,00m².
        `,
      },
      {
        title:
          "O tipo e o tamanho do ambiente influenciam no preço do serviço?",
        content: `
        Sim, o valor de ${price} é válido para qualquer cômodo de até 14,0m², para ambientes integrados temos a regra de 2 ou 3 ambientes com desconto.
        `,
      },
      {
        title:
          "Como é calculado o custo da assessoria para ambientes integrados?",
        content: `
        No caso de ambientes integrados, os valores serão cobrados separadamente de acordo com o ambiente e a função do mesmo. Por exemplo:
        <ul>
        <li>Cozinha com sala de jantar e sala de estar = 3 ambientes;</li>
        <li>Sala de jantar com sala de estar = 2 ambientes;</li>
        <li>Quarto com closet = 2 ambientes;</li>
        <li>Cozinha com área de serviço = 2 ambientes.</li>
        </ul>
        `,
      },
      {
        title: "Ainda não encontrou o que você estava buscando?",
        content: `
        Para outras dúvidas relacionadas ao serviço ${company.name}, basta entrar em contato pelo SAC.
        `,
      },
      {
        title:
          "Precisa decorar mais de 10 ambientes ao mesmo tempo? Temos algumas regras especiais para prazos de envio e revisões, confira:",
        content: `
        <ul>
        <li>Até 10 assessorias: prazo de envio da proposta inicial de 5 (cinco) dias úteis (considerando envio de informações na mesma data) e prazo para revisões de até 3 (três) dias úteis</li>
        <li>De 10 a 20 assessorias: prazo de envio da proposta inicial de até 7 (sete)  dias úteis (considerando envio de informações na mesma data) e prazo para revisões de até 5 (cinco) dias úteis</li>
        <li>De 20 a 30 assessorias: prazo de envio da proposta inicial de até 9 (nove)  dias úteis (considerando envio de informações na mesma data) e prazo para revisões de até 7 (sete) dias úteis</li>
        <li>A cada acréscimo de 10 assessorias os prazos aumentam em 2 dias úteis para envio inicial e para revisões conforme a regra acima.</li>
 </ul>

        `,
      },
      {
        title: "Gostaria de cancelar a compra do meu projeto, é possível?",
        content: `
        Se o desejo de cancelamento ocorrer em até 7 dias da compra e o projeto não tiver sido iniciado, fazemos o estorno da compra de forma a garantir o direito legal de arrependimento. Caso o projeto tenha sido iniciado e não fique satisfeito com o projeto enviado, temos as 2 revisões para o alinhamento das expectativas para assim garantir a sua satisfação com relação ao projeto recebido. 
        `,
      },
    ],
  };

  if (company.label === "leroymerlinprojeta") {
    data = {
      rows: [
        {
          title: `Como funciona o ${company.name}?`,
          content: `${company.name} é o mais novo serviço de projetos de decoração online. Após você selecionar qual ambiente deseja transformar e realizar o pagamento, serão disponibilizados dois questionários para conhecermos um pouquinho mais sobre você:
          <ul>
            <li>Questionário 1: Você vai contar para gente sobre seu estilo e preferências para entregarmos um projeto a sua cara! </li>
            <li>Questionário 2: Vamos conhecer seu espaço: fotos, medidas, planta, móveis que quer incluir no projeto!
            </li>
          </ul>
          Além disso, você também poderá nos enviar outras solicitações extras e referências para nos inspirarmos e após o envio de todas as informações necessárias, o nosso time de designers de interiores irá desenvolver um ambiente personalizado para você em até 5 dias úteis.
          `,
        },
        {
          title: `Como faço para comprar o projeto?`,
          content: `Você pode selecionar o ambiente que deseja decorar e seguir para o carrinho de compras, onde será necessário concluir seu cadastro na plataforma, assim será direcionado para a compra via cartão de crédito ou PIX. Após a confirmação de compra, o ambiente selecionado será liberado na sua plataforma para início da jornada de decoração.`,
        },
        {
          title:
            "Eu enviei as fotos erradas nos questionários iniciais do ambiente. É possível corrigir as imagens enviadas?",
          content: `
          Sim, você pode revisar seu questionário antes do time de designers de interiores começar a trabalhar em cima do seu projeto personalizado. Se tiver dificuldade poderá nos solicitar ajuda pelo SAC.
          `,
        },
        {
          title:
            "Tenho fotos de um ambiente pronto que gostaria de usar como inspiração. Onde posso enviar estas imagens?",
          content: `
          No processo dos questionários será solicitado o envio de imagens e referências para usarmos como inspiração no seu projeto.
          `,
        },
        {
          title: `Já utilizei o serviço ${company.name} e gostaria de ter o mesmo designer de interior em meu próximo ambiente. É possível escolher o profissional que vai realizar o serviço?`,
          content: `
         Não é possível escolher o designer de interior que irá realizar o serviço, porém nosso time é treinado com uma metodologia única que garante a satisfação do cliente.
          `,
        },
        {
          title: "O que está incluso no ambiente final?",
          content: `
          Após a conclusão da etapa de envio de informações, nossos designers de interiores criam o seu ambiente personalizado e, assim que ele estiver pronto, o sistema disponibiliza as imagens 3D para a sua aprovação. <br />
          Com a aprovação do 3D, nossa equipe monta todo o material técnico, que contém: <br />
          - Posicionamento  da decoração; <br />
          - Posicionamento  de luminárias; <br />
          - Sugestão de  acabamentos de paredes; <br />
          - Ambiente decorado com imagens em  3D; <br />
          - Tabelas técnicas de móveis, decoração, luminárias, papel de parede, cortinas, persianas, tapetes e toda a decoração; <br />
          - Considerações para executar a decoração; <br />
          - Dicas úteis e personalizadas de decoração; <br />
          `,
        },
        {
          title:
            "Qual é o formato dos arquivos que fazem parte do material técnico e das imagens em 3D? É necessário ter algum programa especial para abri-los?",
          content: `
          Não é necessário ter programa especial para abrir, pois as imagens serão enviadas em formato JPG e o material técnico em formato PDF.
          `,
        },
        {
          title:
            "É possível abrir as imagens 3D e o material técnico no meu celular?",
          content: `
          Sim, nosso sistema é responsivo para celular.
          `,
        },
        {
          title:
            "Estou recebendo uma mensagem de erro ao tentar abrir as imagens 3D e/ou o material técnico. O que eu faço?",
          content: `
          Poderá fechar o sistema e abrir novamente para atualização. Caso o problema persista favor entrar em contato via SAC e informar o erro.
          `,
        },
        {
          title: `Para quem o serviço ${company.name} é indicado?`,
          content: `
          O ${company.name} é indicado para todos que sonham em ter um ambiente decorado, profissional, prático e acessível. Os projetos de decoração são contratados por ambiente e você tem a liberdade de realizar a decoração de acordo com o seu tempo, com o auxílio total do nosso time durante toda a jornada com o serviço, incluindo imagens 3Ds e um material explicativo como passo a passo para você transformar o seu ambiente na prática.
          `,
        },

        {
          title: "Eu quero reformar, este serviço me atende?",
          content: `
          O ${company.name} é um serviço exclusivamente de decoração online. Ele não abrange modificações estruturais, hidráulicas ou elétricas com aumento de carga. Portanto, caso você busque uma reforma, você deve contratar um arquiteto ou engenheiro local para a execução de um projeto de reforma e nos enviar a planta aprovada para desenvolvermos a decoração.
          `,
        },
        {
          title: "Quais os tipos de ambientes que o serviço abrange?",
          content: `
          O ${company.name} pode ser utilizado em qualquer canto da sua casa que você deseje decorar! Nossos designers de interiores estão à disposição para entregar projetos de decoração para salas de estar, salas de jantar, quartos, cozinhas, banheiros e qualquer outro cômodo que você tenha em mente. Você tem a oportunidade de explicar tudo o que precisa na fase dos questionários no início do serviço para que nós possamos entregar algo do jeito que você deseja.
          `,
        },
        {
          title: "O serviço também é válido para áreas externas?",
          content: `
          Sim, nossos designers de interiores também realizam o serviço de decoração para áreas externas, como varandas e quintais, por exemplo.
          `,
        },
        {
          title: "Qual é o prazo de entrega do serviço Leroy Merlin Decora?",
          content: `
          Após a conclusão da etapa de questionários e envio de informações para o nosso time, o prazo de entrega é de 5 (cinco) dias úteis para o envio do projeto com as imagens 3Ds. Após a aprovação dele pelo cliente, há um prazo de 3 (três) dias úteis para envio do material técnico.
          `,
        },
        {
          title: "É possível solicitar uma revisão e ajustes do projeto?",
          content: `
          Sim, você pode solicitar até 2 (duas) revisões em até 20 (vinte) dias corridos após envio da primeira versão. Caso o cliente não solicite nenhuma revisão dentro do prazo estipulado, o projeto será considerada aprovada pelo sistema e o material técnico será enviado em 3 (três) dias úteis.
          `,
        },
        {
          title:
            "Eu aprovei o ambiente 3D, mas gostaria de solicitar uma revisão. É possível voltar atrás?",
          content: `
          Não. Depois que o cliente aprova as imagens 3D, nossos designer de interior já iniciam a elaboração do material técnico, o que impede qualquer nova alteração. Poderá ser feita solicitação de revisão extra no valor de R$99,00 via SAC.
          `,
        },
        {
          title:
            "Eu gostaria de aproveitar alguns móveis que já tenho. Como posso informar e incluí-los no meu projeto de decoração?",
          content: `
          Para aproveitar seus móveis atuais, você só precisa nos enviar as fotos e medidas de todos os objetos que deseja manter e vamos considerá-los na elaboração do seu projeto.
          `,
        },
        {
          title: `Eu posso contratar o serviço ${company.name} nas lojas físicas?`,
          content: `
          No momento, o serviço está apenas disponível em nosso site.
          `,
        },
        {
          title: `Qual é o custo do serviço ${company.name}?`,
          content: `
          O serviço possui um valor padrão de ${price} por ambiente. Além disso, oferecemos descontos progressivos no valor do projeto de 8% na compra de 2 (dois) ambientes e 12% na compra de 3 (três) ou mais ambiente em um único pedido de compra. Oferecemos também um cupom de 10% de desconto para você realizar a compra da lista de produtos indicada no seu projeto de decoração.
          `,
        },
        {
          title:
            "O tipo e o tamanho do ambiente influenciam no preço do serviço?",
          content: `
          Sim, o valor de ${price} é válido para qualquer cômodo de até 14,0m², para ambientes integrados temos a regra de 2 ou 3 ambientes com desconto.
          `,
        },
        {
          title:
            "Como é calculado o custo do serviço para ambientes integrados?",
          content: `
          No caso de ambientes integrados, os valores serão cobrados separadamente de acordo com o ambiente e a função do mesmo. Por exemplo:
          <ul>
          <li>Cozinha com sala de jantar e sala de estar = 3 ambientes;</li>
          <li>Sala de jantar com sala de estar = 2 ambientes;</li>
          <li>Quarto com closet = 2 ambientes;</li>
          <li>Cozinha com área de serviço = 2 ambientes.</li>
          </ul>
          Oferecemos descontos progressivos no valor do projeto de 8% na compra de 2 (dois) ambientes e 12% na compra de 3 (três) ou mais ambiente em um único pedido de compra.
          `,
        },
        {
          title: "Ainda não encontrou o que você estava buscando?",
          content: `
          Para outras dúvidas relacionadas ao serviço ${company.name}, basta entrar em contato pelo SAC.
          `,
        },
        {
          title:
            "Precisa decorar mais de 10 ambientes ao mesmo tempo? Temos algumas regras especiais para prazos de envio e revisões, confira:",
          content: `
          <ul>
          <li>Até 10 ambientes: prazo de envio da proposta inicial de 5 (cinco) dias úteis (considerando envio de informações na mesma data) e prazo para revisões de até 3 (três) dias úteis</li>
          <li>De 10 a 20 ambientes: prazo de envio da proposta inicial de até 7 (sete)  dias úteis (considerando envio de informações na mesma data) e prazo para revisões de até 5 (cinco) dias úteis</li>
          <li>De 20 a 30 ambientes: prazo de envio da proposta inicial de até 9 (nove)  dias úteis (considerando envio de informações na mesma data) e prazo para revisões de até 7 (sete) dias úteis</li>
          <li>A cada acréscimo de 10 ambientes os prazos aumentam em 2 dias úteis para envio inicial e para revisões conforme a regra acima.</li>
   </ul>
  
          `,
        },
        {
          title: "Gostaria de cancelar a compra do meu projeto, é possível?",
          content: `
          Se o desejo de cancelamento ocorrer em até 7 dias da compra e o projeto não tiver sido iniciado, fazemos o estorno da compra de forma a garantir o direito legal de arrependimento. Caso o projeto tenha sido iniciado e não fique satisfeito com o projeto enviado, temos as 2 revisões para o alinhamento das expectativas para assim garantir a sua satisfação com relação ao projeto recebido. Se mesmo após a utilização das 2 revisões ainda estiver insatisfeito com o projeto, poderá ser feita a solicitação de revisão extra no valor de R$ 99,00 via SAC.
          `,
        },
      ],
    };
  }

  const styles = {
    rowContentColor: "#686868",
    rowTitleColor: "#3C3C3E",
    rowContentPaddingLeft: "10px",
    rowContentPaddingRight: "10px",
    rowContentPaddingTop: "10px",
    rowTitleTextSize: "16px",
    rowContentTextSize: "15px",
  };

  return (
    <Container fluid className="main-content-container px-4">
      <Row className="page-header py-4">
        <Col>
          <PageTitle title="FAQ" className="text-sm-left mb-3" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Card small className="mb-4">
            <CardHeader className="border-bottom" />
            <CardBody className="p-0 pb-3">
              <Col />
              <Col>
                <Faq data={data} styles={styles} />
              </Col>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FaqPlataforma;
